"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _isParentValue = _interopRequireDefault(require("./isParentValue"));

var _clear = _interopRequireDefault(require("unmutable/lib/clear"));

var _get = _interopRequireDefault(require("unmutable/lib/get"));

var _reduce = _interopRequireDefault(require("unmutable/lib/reduce"));

var _shallowToJS = _interopRequireDefault(require("unmutable/lib/shallowToJS"));

var _pipeWith = _interopRequireDefault(require("unmutable/lib/util/pipeWith"));

var _default = function _default() {
  return function (parcelData) {
    var value = parcelData.value,
        child = parcelData.child;

    if (!(0, _isParentValue["default"])(value)) {
      var _child = parcelData.child,
          rest = (0, _objectWithoutProperties2["default"])(parcelData, ["child"]);
      /* eslint-disable-line no-unused-vars */

      return rest;
    }

    return (0, _objectSpread2["default"])({}, parcelData, {
      child: (0, _pipeWith["default"])(value, (0, _reduce["default"])(function (red, value, key) {
        red[key] = child ? (0, _get["default"])(key, {})(child) : {};
        return red;
      }, (0, _pipeWith["default"])(value, (0, _clear["default"])(), (0, _shallowToJS["default"])())))
    });
  };
};

exports["default"] = _default;